<!--
工单进展
 -->

<template>
  <div class="progress">

    <ul class="progress-list">
      <li class="item center" v-if="!tableData.length">暂无数据</li>
      <li class="item" v-for="item in tableData" :class="{'status': item.status}">
        <div class="left-part" :class="'bg-'+item.status">
          <div class="state" v-if="item.state">{{item.state}}</div>
          <div class="date">{{item.addTime | formatTimeCompare}}</div>
        </div>
        <div class="right-part">
          <div class="title">
            <span class="circle">
              <img :src="item.user.userAvatar" :alt="item.user.userName">
            </span>
            <span class="name">{{item.user.userName}}</span>
          </div>
          <ul class="pro-list">
            <li class="node" :class="[node.isOut ? 'red' : 'bg-'+item.status]" v-for="node in item.process">
              <span class="text"> {{node.content}}</span>
              <span class="date">{{node.time || '--'}}</span>
            </li>
          </ul>
          <div class="memo" v-if="item.memo">{{item.memo}}</div>
          <div class="outTimeMsg" v-if="item.outTimeMsg">{{item.outTimeMsg}}</div>
          <span class="status" :class="'col-'+item.status">{{item.statusName}}</span>
        </div>
      </li>
    </ul>

    <div class="load-more">
      <template v-if="showLoadmore">
        <i class="el-icon-loading"></i>
        加载更多
      </template>
      <template v-if="!showLoadmore && page.total>page.size">没有更多</template>
    </div>
  </div>
</template>

<script>
import * as api from 'src/api'

export default {

  name: 'divprogress',

  props: {
    id: {
      type: Number
    },
    loading: {
      type: Number,
      default: 1
    }
  },

  data () {
    return {
      tableData: [],
      date: [],
      // 分页信息
      page: {
        size: 50,
        total: '',
        page: 1,
        rows: 1
      }
    }
  },

  computed: {
    // 是否显示加载更多
    showLoadmore () {
      if (this.page.total > this.page.size && this.page.rows > this.page.page) {
        return true
      } else {
        return false
      }
    }
  },

  created () {
    this.getList()
  },

  methods: {
    getList () {
      let url = '/workOrder/getProgress.html'
      let params = {
        id: this.id,
        page: this.page.page,
        pageSize: this.page.size
      }
      api.post(url, params, (data) => {
        this.page.total = data.pageHelper.rowsCount
        this.page.rows = data.pageHelper.pageTotal

        // 通过page.page来判断当前是刷新还是下拉加载更多
        if (this.page.page === 1) {
          this.tableData = data.result
        } else {
          this.tableData = this.tableData.concat(data.result)
        }
      })
    },
    // 加载更多
    loadmore () {
      this.page.page++
      this.getList()
    }
  },

  filters: {
    formatTimeCompare (time) {
      return window.utils.formatTimeCompare(time)
    },
    statusText (num) {
      return 'text'
    }
  },

  watch: {
    loading () {
      if (this.page.rows > this.page.page) {
        this.loadmore()
      }
    }
  }
}
</script>

<style lang="less" scoped>
  @import '../../../assets/less/variable.less';
  @col1: #5e97f6;
  @col2: #ff943e;
  @col3: #78c06e;
  @col4: #929292;
  @col5: #FF6161;
  @col6: #9A89B9;

  .progress {
    .progress-list {
      position: relative;
      min-width: 660px;
      .item {
        position: relative;
        padding-top: 5px;
        padding-bottom: 20px;
        &:before {
          position: absolute;
          content: "";
          height: 100%;
          width: 0;
          border-left: 1px solid #DCE1E8;
          left: 128px;
          top: 0;
        }
        &.center {
          text-align: center;
          line-height: 5;
          &:before {
            display: none;
          }
        }
        .left-part {
          display: inline-block;
          width: 100px;
          vertical-align: top;
          text-align: right;
          padding-top: 18px;
          position: relative;
          &:before {
            position: absolute;
            content: "";
            width: 20px;
            height: 0px;
            border-bottom: 1px solid #DCE1E8;
            right: -28px;
            top: 28px;
          }
          &:after {
            position: absolute;
            content: "";
            width: 8px;
            height: 8px;
            border-radius: 4px;
            right: -32.5px;
            top: 24.5px;
          }
          .state {
            font-size: 15px;
            color: @light-blue;
            line-height: 22px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          .date {
            font-size: 13px;
            line-height: 16px;
            color: @light-gray;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
        .right-part {
          position: relative;
          width: 480px;
          display: inline-block;
          vertical-align: top;
          border-radius: 2px;
          background-color: #fff;
          margin-left: 50px;
          box-shadow: 0 0 6px 0 rgba(105, 105, 105, 0.5);
          padding: 15px;
          box-sizing: border-box;
          &:before {
            position: absolute;
            left: -8px;
            top: 21px;
            content: '';
            width: 16px;
            height: 16px;
            transform: rotate(45deg);
            background-color: #fff;
            box-shadow: 0 0 4px 0 rgba(105, 105, 105, 0.5);
          }
          &:after {
            position: absolute;
            left: 0;
            top: 16px;
            content: '';
            width: 12px;
            height: 26px;
            background-color: #fff;
          }
          .title {
            font-size: 0;
            .circle {
              display: inline-block;
              vertical-align: top;
              width: 32px;
              height: 32px;
              border-radius: 16px;
              overflow: hidden;
              background-color: #6EC7AD;
              color: #fff;
              font-size: 13px;
              img {
                width: 100%;
                height: 100%;
                display: block;
              }
            }
            .name {
              display: inline-block;
              vertical-align: top;
              font-size: 13px;
              line-height: 32px;
              margin-left: 10px;
            }
          }
          .pro-list {
            margin-top: 15px;
            .node {
              position: relative;
              font-size: 13px;
              line-height: 1;
              padding: 0 0 10px 15px;
              color: #808080;
              &:after {
                content: "";
                width: 4px;
                height: 4px;
                border-radius: 2px;
                position: absolute;
                left: 0;
                top: 4px;
              }

              .date {
                position: absolute;
                right: 0;
                top: 0;
                color: @light-gray;
              }
            }
          }
          .outTimeMsg {
            font-size: 13px;
            color: red;
            margin-top: 12px;
          }
          .memo {
            font-size: 13px;
            color: @light-gray;
            position: relative;
            line-height: 1.5;
            padding-left: 40px;
            &:before {
              content: "备注：";
              position: absolute;
              left: 0;
            }
            padding-bottom: 10px;
            border-bottom: 1px dashed #d8d8d8;
          }
          .status {
            position: absolute;
            right: 15px;
            top: 24px;
            &.col-1 {
              color: @col1;
            }
            &.col-2 {
              color: @col2;
            }
            &.col-3 {
              color: @col3;
            }
            &.col-4 {
              color: @col4;
            }
            &.col-5 {
              color: @col5;
            }
            &.col-6 {
              color: @col6;
            }
          }
        }
      }
      .bg-1 {
        &:after {
          background-color: @col1;
        }
      }
      .bg-2 {
        &:after {
          background-color: @col2;
        }
      }
      .bg-3 {
        &:after {
          background-color: @col3;
        }
      }
      .bg-4 {
        &:after {
          background-color: @col4;
        }
      }
      .bg-5 {
        &:after {
          background-color: @col5;
        }
      }
      .bg-6 {
        &:after {
          background-color: @col6;
        }
      }
      .red {
        &:after {
          background-color: @bg-red;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// divprogress.vue?234625a4